module.exports = __webpack_public_path__ + "img/wx2x.b7c7828f.png";